module.exports = __webpack_public_path__ + "static/media/b-sci-major-15_LR.7633fb8d.jpg";